module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/record/record.component.css
// module id = ./src/app/record/record.component.css
// module chunks = main